module.exports = __webpack_public_path__ + "img/bnn.9ca15bda.svg";